import { ValidatorFn } from '@angular/forms';

/**
 * Bewaakt dat de eindtijd na de begintijd ligt.
 *
 */
export const dateRangeValidator: ValidatorFn = control => {
    const endtime = control.value;
    const begintime = control.parent?.get('begintime')?.value;
    if (!endtime || !begintime) {
        return null;
    }
    return new Date(endtime).getTime() < new Date(begintime).getTime() ? { enddateBeforeBegindate: true } : null;
};
